import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { VariablesService, VwoService } from '../../shared/services';

@Component({
  selector: 'app-offer-tag',
  templateUrl: './offer-tag.component.html',
  styleUrls: ['./offer-tag.component.scss']
})
export class OfferTagComponent implements OnInit, OnDestroy {

  activatedOffer;
  params;
  subs: Subscription[] = [];
  offerpriority = false;

  constructor(
    public variablesService: VariablesService,
    public actRoute: ActivatedRoute,
    public vwo: VwoService
  ) { }

  ngOnInit(): void {
    this.subs.push(this.actRoute.queryParams.subscribe(p => {
      this.params = p;
      if (this.params?.offer) {
        this.offerpriority = true;
      }
    }));
    this.subs.push(this.variablesService.offerActivated.subscribe(res => {
      this.activatedOffer = res;
    }));
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

}
